import { render } from "./ProfileCreateComponent.vue?vue&type=template&id=619fdf9e&scoped=true"
import script from "./ProfileCreateComponent.vue?vue&type=script&lang=js"
export * from "./ProfileCreateComponent.vue?vue&type=script&lang=js"

import "./ProfileCreateComponent.vue?vue&type=style&index=0&id=619fdf9e&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-619fdf9e"]])

export default __exports__